import {observer} from "mobx-react";
import {LayoutPagePromptManagement, LayoutContentPromptManagement} from "../components";
import {usePromptManagementStore} from "../hooks";
import React, {useEffect} from "react";
import {PromptManagementSystemPagesTypes} from "../types";
import {useStore} from "../../../../hooks";
import Spinner from "../../../../components/common/Spinner";

export const PromptManagementCreate = observer(() => {
  const { authStore } = useStore();
  const store = usePromptManagementStore();
  const { currentPrompt, isLoading } = store;

  useEffect(() => {
    store.onChangePage(authStore.currentWorkspaceUuid, PromptManagementSystemPagesTypes.PAGE_CREATE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store]);
  
  return (
    <>
      {isLoading && (<Spinner dataTestId="spinner" />)}
      {!isLoading && currentPrompt &&
        (
          <LayoutPagePromptManagement title="Provide a Clear and Descriptive Prompt">
            <LayoutContentPromptManagement />
          </LayoutPagePromptManagement>
        )}
    </>
  );
});
